// src/services/guestHouseService.js
import apiClient from './apiClient';

const GUESTHOUSE_ENDPOINT = '/guestHouse';

export const guestHouseService = {
  // Get all guest houses
  async getGuestHouseList(includeImages = true) {
    try {
      const response = await apiClient.get(`${GUESTHOUSE_ENDPOINT}/getGuestHouses`, {
        params: {
          includeImages
        }
      });
      
      return response.data;
    } catch (error) {
      // Handle specific error responses
      if (error.response) {
        throw new Error(error.response.data.message || 'Failed to fetch guest houses');
      }
      throw new Error('Network error. Please try again later.');
    }
  },

  // Get guest house by ID
  async getGuestHouseById(id, includeImages = true) {
    try {
      const response = await apiClient.get(`${GUESTHOUSE_ENDPOINT}/getGuestHouseDetailsById/${id}`
        , {
        params: {
          includeImages
        }
      }
    );
      
      return response.data;
    } catch (error) {
      if (error.response) {
        throw new Error(error.response.data.message || 'Failed to fetch guest house details');
      }
      throw new Error('Network error. Please try again later.');
    }
  },
  
  async getGuestHouseRoomsDetailById(id, checkInDate = null, checkOutDate = null) {
    try {
      let url = `${GUESTHOUSE_ENDPOINT}/getGuestHouseRoomsDetailById/${id}`;
      
      // Add query parameters if dates are provided
      const params = new URLSearchParams();
      if (checkInDate) params.append('checkInDate', checkInDate);
      if (checkOutDate) params.append('checkOutDate', checkOutDate);
      
      // Append query string to URL if we have parameters
      const queryString = params.toString();
      if (queryString) {
        url += `?${queryString}`;
      }
      
      const response = await apiClient.get(url);
      
      return response.data;
    } catch (error) {
      if (error.response) {
        throw new Error(error.response.data.message || 'Failed to fetch guest house details');
      }
      throw new Error('Network error. Please try again later.');
    }
  },
}

export default guestHouseService;